import Principal from "./components/Principal/Principal";
import "./App.css"
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#3CAEC7',
      dark: '#266168',
      contrastText: '#fff',
      complementary: '#c7553c',
      analogous: '#3cc79b',
      triadic: '#553cc7',
      light: '#c7a43c',

    },

  },
});


function App() {
  return (

    <ThemeProvider theme={theme}>
      <Principal />
    </ThemeProvider>


  );
}

export default App;
